var exports = {
  "h": "ThreadHeaderIconButton__wXFb1i",
};

module.exports = exports;
